import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import ReactGA from "react-ga4";
import { useRecoilState } from "recoil";
import { profileState } from "./atoms/user/profile-state";
import { getAccessToken } from "./common/util/get-access-token";
import { removeAccessToken } from "./common/util/remove-access-token";
import { GlobalHeader } from "./components/header/GlobalHeader/GlobalHeader";
import { MobileWarningPanel } from "./components/panel/MobileWarningPanel";
import { AuthRouter } from "./router/AuthRouter";
import { MainRouter } from "./router/MainRouter";
import { userService } from "./services/user-service";

function App() {
  const [profile, setProfile] = useRecoilState(profileState);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [checkLogin, setCheckLogin] = useState<boolean>(false);

  const autoSignIn = async () => {
    try {
      const response = await userService.getMe();
      if (!response.ok) {
        removeAccessToken();
        return;
      }
      setProfile(response.data);
    } catch (error) {
      console.log(error);
      removeAccessToken();
    }
  };

  useEffect(() => {
    const accessToken = getAccessToken();
    if (accessToken) {
      autoSignIn();
    } else {
      setCheckLogin(true);
    }

    if (process.env.REACT_APP_GA_KEY) {
      ReactGA.initialize(process.env.REACT_APP_GA_KEY);
      ReactGA.send("pageview");
    }
  }, []);

  useEffect(() => {
    if (checkLogin) {
      setIsLoading(false);
    }
  }, [checkLogin]);

  useEffect(() => {
    if (profile) {
      setCheckLogin(true);
    }
  }, [profile]);

  if (isMobile) {
    return <MobileWarningPanel />;
  }

  return (
    <div className="w-screen h-screen">
      {!isLoading && (
        <>
          {profile ? (
            <div className="flex flex-col h-screen">
              <GlobalHeader />
              <div className="bg-grayscale-contrast-2 flex flex-grow">
                <MainRouter />
              </div>
            </div>
          ) : (
            <AuthRouter />
          )}
        </>
      )}
    </div>
  );
}

export default App;
